(() => {
  const SELECTORS = {
    section: '[data-scandal-bundle-builder]',
    card: '[data-bundle-card]',
    qtyInput: '[data-qty-input]',
    plus: '[data-qty-plus]',
    minus: '[data-qty-minus]',
    addButton: '[data-add-bundle]',
    selectedCount: '[data-selected-count]',
    footerCount: '[data-footer-count]',
    footerMessage: '[data-footer-message]',
    selectedList: '[data-selected-list]',
    error: '[data-bundle-error]',
    search: '[data-bundle-search]',
    modal: '[data-bundle-modal]',
    modalBody: '[data-bundle-modal-body]',
    modalOpen: '[data-bundle-modal-open]',
    modalClose: '[data-bundle-modal-close]',
    modalSource: '[data-bundle-modal-source]',
    grid: '[data-bundle-grid]',
    sliderMeta: '[data-bundle-slider-meta]',
    sliderDots: '[data-bundle-slider-dots]',
    sliderCount: '[data-bundle-slider-count]',
    pipetteCheckbox: '[data-bundle-pipette-checkbox]'
  };

  function moneySafe(value) {
    return typeof value === 'string' ? value : '';
  }

  function toNumber(value, fallback = 0) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function isTrue(value) {
    return value === true || value === 'true';
  }

  function applyBundleUrlConfig(section) {
    const params = new URLSearchParams(window.location.search);
    const configKeys = ['bundle_qty', 'bundle_discount', 'bundle_title', 'bundle_price'];

    if (!configKeys.some(key => params.has(key))) return;

    const fallbackQuantity = toNumber(section.dataset.requiredQuantity, 4);
    const requestedQuantity = Number.parseInt(params.get('bundle_qty'), 10);
    const requiredQuantity = Number.isInteger(requestedQuantity) && requestedQuantity >= 1 && requestedQuantity <= 24
      ? requestedQuantity
      : fallbackQuantity;

    const fallbackDiscount = (section.dataset.discountCode || '').trim();
    const hasDiscountParam = params.has('bundle_discount');
    const requestedDiscount = (params.get('bundle_discount') || '')
      .trim()
      .replace(/[^a-zA-Z0-9_-]/g, '')
      .slice(0, 64);
    const discountCode = hasDiscountParam ? requestedDiscount : fallbackDiscount;

    const fallbackTitle = section.dataset.bundleTitle || 'Scandal Bundle';
    const title = ((params.get('bundle_title') || fallbackTitle).trim() || 'Scandal Bundle').slice(0, 100);
    const price = ((params.get('bundle_price') || '').trim()).slice(0, 40);

    section.dataset.requiredQuantity = String(requiredQuantity);
    section.dataset.discountCode = discountCode;
    section.dataset.bundleTitle = title;

    const heading = section.querySelector('.sc-bundle-builder__heading');
    const summaryTitle = section.querySelector('.sc-bundle-builder__summary-title');
    const offer = section.querySelector('.sc-bundle-builder__offer');
    const addButton = section.querySelector(SELECTORS.addButton);
    const breadcrumb = section.querySelector('.sc-bundle-builder__breadcrumbs [aria-current="page"]');

    if (heading) heading.textContent = `Build Your Scandal ${title}`;
    if (summaryTitle) summaryTitle.textContent = `Your ${title}`;
    if (offer) offer.textContent = price
      ? `Build your ${title} for ${price}.`
      : `Build your ${title}.`;
    if (addButton) addButton.textContent = `Add ${title} to Cart`;
    if (breadcrumb) breadcrumb.textContent = `Build Your ${title}`;

    section.querySelectorAll('[data-required-quantity-label]').forEach(element => {
      element.textContent = String(requiredQuantity);
    });
  }

  async function fetchCartQuantities() {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return {};

      const cart = await response.json();
      const quantities = {};

      if (!cart || !Array.isArray(cart.items)) return quantities;

      cart.items.forEach(item => {
        const id = String(item.variant_id);
        quantities[id] = (quantities[id] || 0) + Number(item.quantity || 0);
      });

      return quantities;
    } catch (error) {
      return {};
    }
  }

  function initBundleBuilder(section) {
    if (!section) return;

    applyBundleUrlConfig(section);

    if (section.dataset.scandalBundleReady === 'true') return;

    section.dataset.scandalBundleReady = 'true';

    const requiredQuantity = toNumber(section.dataset.requiredQuantity, 4);
    const maxPerFlavour = toNumber(section.dataset.maxPerFlavour, 8);
    const cartRedirect = isTrue(section.dataset.cartRedirect);
    const discountCode = (section.dataset.discountCode || '').trim();
    const bundleTitle = section.dataset.bundleTitle || 'Scandal Bundle';

    const cards = Array.from(section.querySelectorAll(SELECTORS.card));
    const addButton = section.querySelector(SELECTORS.addButton);
    const selectedCount = section.querySelector(SELECTORS.selectedCount);
    const footerCount = section.querySelector(SELECTORS.footerCount);
    const footerMessage = section.querySelector(SELECTORS.footerMessage);
    const selectedList = section.querySelector(SELECTORS.selectedList);
    const errorEl = section.querySelector(SELECTORS.error);
    const searchInput = section.querySelector(SELECTORS.search);
    const pipetteCheckbox = section.querySelector(SELECTORS.pipetteCheckbox);
    const pipetteVariantId = 54066631835987;

    let cartQuantities = {};
    let modalLastTrigger = null;

    function clearError() {
      if (!errorEl) return;

      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function showError(message) {
      if (!errorEl) return;

      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function getInput(card) {
      return card.querySelector(SELECTORS.qtyInput);
    }

    function getQty(card) {
      const input = getInput(card);
      return input ? toNumber(input.value, 0) : 0;
    }

    function setQty(card, quantity) {
      const input = getInput(card);
      if (!input) return;

      const safeQuantity = Math.max(0, toNumber(quantity, 0));
      input.value = String(safeQuantity);
    }

    function isCardAvailable(card) {
      return isTrue(card.dataset.available);
    }

    function isInventoryTracked(card) {
      return isTrue(card.dataset.inventoryTracked);
    }

    function allowsOversell(card) {
      return isTrue(card.dataset.allowsOversell);
    }

    function getVariantId(card) {
      return String(card.dataset.variantId || '');
    }

    function getRawMaxAvailable(card) {
      if (!isCardAvailable(card)) return 0;

      if (!isInventoryTracked(card) || allowsOversell(card)) {
        return maxPerFlavour;
      }

      const liquidMax = toNumber(card.dataset.maxAvailable, 0);

      return Math.max(0, Math.min(liquidMax, maxPerFlavour));
    }

    function getExistingCartQty(card) {
      const variantId = getVariantId(card);
      if (!variantId) return 0;

      return toNumber(cartQuantities[variantId], 0);
    }

    function getEffectiveMaxAvailable(card) {
      if (!isCardAvailable(card)) return 0;

      const rawMax = getRawMaxAvailable(card);

      if (!isInventoryTracked(card) || allowsOversell(card)) {
        return rawMax;
      }

      const alreadyInCart = getExistingCartQty(card);
      return Math.max(0, rawMax - alreadyInCart);
    }

    function updateInputMaximums() {
      cards.forEach(card => {
        const input = getInput(card);
        if (!input) return;

        const max = getEffectiveMaxAvailable(card);
        input.max = String(max);

        const qty = getQty(card);
        if (qty > max) {
          setQty(card, max);
        }
      });
    }

    function getSelectedTotal() {
      return cards.reduce((total, card) => {
        return total + getQty(card);
      }, 0);
    }

  function getSelectedCards() {
  return cards
    .map(card => {
      return {
        card,
        title: card.dataset.productTitle || 'Cookie',
        variantId: getVariantId(card),
        qty: getQty(card),
        pipetteEligible: isTrue(card.dataset.pipetteEligible)
      };
    })
    .filter(item => item.qty > 0);
}

    function renderSelectedList(selectedItems) {
      if (!selectedList) return;

      selectedList.innerHTML = '';

      if (!selectedItems.length) {
        const empty = document.createElement('li');
        empty.className = 'sc-bundle-builder__selected-empty';
        empty.textContent = 'No cookies selected yet.';
        selectedList.appendChild(empty);
        return;
      }

      selectedItems.forEach(item => {
        const li = document.createElement('li');
        li.className = 'sc-bundle-builder__selected-item';

        const name = document.createElement('span');
        name.className = 'sc-bundle-builder__selected-name';
        name.textContent = item.title;

        const qty = document.createElement('span');
        qty.className = 'sc-bundle-builder__selected-qty';
        qty.textContent = `Ã— ${item.qty}`;

        li.appendChild(name);
        li.appendChild(qty);
        selectedList.appendChild(li);
      });
    }

    function updateControls() {
      updateInputMaximums();

      const total = getSelectedTotal();
      const selectedItems = getSelectedCards();

      const eligiblePipetteQty = selectedItems.reduce((sum, item) => {
        return item.pipetteEligible ? sum + item.qty : sum;
      }, 0);

      if (pipetteCheckbox) {
        const pipetteBox = pipetteCheckbox.closest('[data-bundle-pipette]');
        const pipetteDisabled = eligiblePipetteQty <= 0;

        pipetteCheckbox.disabled = pipetteDisabled;

        if (pipetteDisabled) {
          pipetteCheckbox.checked = false;
        }

        if (pipetteBox) {
          pipetteBox.classList.toggle('is-disabled', pipetteDisabled);

          const text = pipetteBox.querySelector('[data-bundle-pipette-dynamic-text]');
          if (text) {
            text.textContent = pipetteDisabled
              ? 'No sauce pipettes available for your current selection.'
              : `${eligiblePipetteQty} sauce pipette${eligiblePipetteQty === 1 ? '' : 's'} available for your current selection.`;
          }
        }
      }

      if (selectedCount) {
        selectedCount.textContent = String(total);
      }

      if (footerCount) {
        footerCount.textContent = `${total} / ${requiredQuantity}`;
      }

      if (footerMessage) {
        if (total === 0) {
          footerMessage.textContent = `Choose ${requiredQuantity} cookies to complete your box.`;
        } else if (total < requiredQuantity) {
          footerMessage.textContent = `Choose ${requiredQuantity - total} more.`;
        } else if (total === requiredQuantity) {
          footerMessage.textContent = 'Your box is ready.';
        } else {
          footerMessage.textContent = `Remove ${total - requiredQuantity} to complete your box.`;
        }
      }

      cards.forEach(card => {
        const qty = getQty(card);
        const maxAvailable = getEffectiveMaxAvailable(card);
        const plus = card.querySelector(SELECTORS.plus);
        const minus = card.querySelector(SELECTORS.minus);
        const available = isCardAvailable(card);

        card.classList.toggle('is-selected', qty > 0);
        card.classList.toggle('is-stock-blocked', available && maxAvailable <= 0);

        if (minus) {
          minus.disabled = !available || qty <= 0;
        }

        if (plus) {
          plus.disabled =
            !available ||
            maxAvailable <= 0 ||
            qty >= maxAvailable ||
            total >= requiredQuantity;
        }
      });

      renderSelectedList(selectedItems);

      if (addButton) {
        addButton.disabled = total !== requiredQuantity;
      }

      updateSliderMeta();
    }

    function increaseQty(card) {
      clearError();

      const title = card.dataset.productTitle || 'this flavour';
      const currentQty = getQty(card);
      const total = getSelectedTotal();
      const maxAvailable = getEffectiveMaxAvailable(card);
      const alreadyInCart = getExistingCartQty(card);

      if (!isCardAvailable(card)) {
        showError(`${title} is currently sold out.`);
        return;
      }

      if (maxAvailable <= 0) {
        if (alreadyInCart > 0) {
          showError(`${title} is already using the available stock in your cart.`);
        } else {
          showError(`${title} is currently sold out.`);
        }
        return;
      }

      if (currentQty >= maxAvailable) {
        showError(`Only ${maxAvailable} available for ${title}.`);
        return;
      }

      if (total >= requiredQuantity) {
        showError('Your box is already full. Remove one flavour first.');
        return;
      }

      setQty(card, currentQty + 1);
      updateControls();
    }

    function decreaseQty(card) {
      clearError();

      const currentQty = getQty(card);

      if (currentQty <= 0) return;

      setQty(card, currentQty - 1);
      updateControls();
    }

    function validateBeforeAdd() {
      const total = getSelectedTotal();

      if (total !== requiredQuantity) {
        showError(`Choose exactly ${requiredQuantity} cookies to complete this box.`);
        return false;
      }

      const selectedItems = getSelectedCards();

      for (const item of selectedItems) {
        const maxAvailable = getEffectiveMaxAvailable(item.card);

        if (!item.variantId) {
          showError(`${item.title} has no valid variant ID.`);
          return false;
        }

        if (!isCardAvailable(item.card)) {
          showError(`${item.title} is currently sold out.`);
          return false;
        }

        if (maxAvailable <= 0) {
          showError(`${item.title} is no longer available.`);
          return false;
        }

        if (item.qty > maxAvailable) {
          showError(`Only ${maxAvailable} available for ${item.title}.`);
          return false;
        }
      }

      return true;
    }

    function getCartRedirectUrl() {
      if (!discountCode) return '/cart';

      return `/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent('/cart')}`;
    }

    async function addBundleToCart() {
      clearError();

      if (!addButton) return;

      cartQuantities = await fetchCartQuantities();
      updateControls();

      if (!validateBeforeAdd()) return;

      const selectedItems = getSelectedCards();

     const pipetteQty =
  pipetteCheckbox && pipetteCheckbox.checked
    ? selectedItems.reduce((total, item) => {
        return item.pipetteEligible ? total + item.qty : total;
      }, 0)
    : 0;

const items = selectedItems.map(item => {
  return {
    id: Number(item.variantId),
    quantity: item.qty,
    properties: {
      '_Bundle': bundleTitle,
      '_Bundle size': String(requiredQuantity),
      'Sauce pipette':
        pipetteCheckbox && pipetteCheckbox.checked && item.pipetteEligible
          ? 'Yes - matching sauce'
          : 'No'
    }
  };
});

if (pipetteQty > 0) {
  items.push({
    id: pipetteVariantId,
    quantity: pipetteQty,
    properties: {
      '_Bundle': bundleTitle,
      '_Bundle add-on': 'Matching sauce pipettes',
      '_Pipettes for eligible cookies': String(pipetteQty)
    }
  });
}

      const originalText = addButton.textContent;

      addButton.disabled = true;
      addButton.textContent = 'Adding...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        const data = await response.json().catch(() => null);

        if (!response.ok) {
          const message =
            data?.description ||
            data?.message ||
            'One of these flavours no longer has enough stock. Refresh the page and try again.';

          throw new Error(message);
        }

        cartQuantities = await fetchCartQuantities();

        if (cartRedirect) {
          window.location.href = getCartRedirectUrl();
          return;
        }

        addButton.textContent = 'Added';
        setTimeout(() => {
          addButton.textContent = originalText;
          updateControls();
        }, 1600);
      } catch (error) {
        showError(error.message || 'Something went wrong. Refresh the page and try again.');
        addButton.textContent = originalText;
        updateControls();
      }
    }

    function handleSearch() {
      if (!searchInput) return;

      const query = searchInput.value.trim().toLowerCase();

      cards.forEach(card => {
        const title = (card.dataset.productTitle || '').toLowerCase();
        const shouldShow = !query || title.includes(query);

        card.style.display = shouldShow ? '' : 'none';
      });

      updateSliderMeta(true);
    }

    function initQuantityButtons() {
      cards.forEach(card => {
        const plus = card.querySelector(SELECTORS.plus);
        const minus = card.querySelector(SELECTORS.minus);

        if (plus) {
          plus.addEventListener('click', () => increaseQty(card));
        }

        if (minus) {
          minus.addEventListener('click', () => decreaseQty(card));
        }
      });

      if (addButton) {
        addButton.addEventListener('click', addBundleToCart);
      }

      if (searchInput) {
        searchInput.addEventListener('input', handleSearch);
      }
    }

    function initModal() {
      const modal = section.querySelector(SELECTORS.modal);
      const modalBody = section.querySelector(SELECTORS.modalBody);
      const closeButtons = section.querySelectorAll(SELECTORS.modalClose);

      if (!modal || !modalBody) return;

      function openModal(trigger) {
        const card = trigger.closest(SELECTORS.card);
        if (!card) return;

        const source = card.querySelector(SELECTORS.modalSource);
        if (!source) return;

        modalLastTrigger = trigger;
        modalBody.innerHTML = source.innerHTML;
        modal.hidden = false;

        document.documentElement.classList.add('sc-bundle-modal-is-open');

        const closeButton = modal.querySelector(SELECTORS.modalClose);
        if (closeButton) closeButton.focus();
      }

      function closeModal() {
        modal.hidden = true;
        modalBody.innerHTML = '';
        document.documentElement.classList.remove('sc-bundle-modal-is-open');

        if (modalLastTrigger) {
          modalLastTrigger.focus();
        }
      }

      section.addEventListener('click', event => {
        const trigger = event.target.closest(SELECTORS.modalOpen);
        if (!trigger) return;

        event.preventDefault();
        event.stopPropagation();

        openModal(trigger);
      });

      closeButtons.forEach(button => {
        button.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !modal.hidden) {
          closeModal();
        }
      });
    }

    const slider = {
      scroller: section.querySelector(SELECTORS.grid),
      meta: section.querySelector(SELECTORS.sliderMeta),
      dotsWrap: section.querySelector(SELECTORS.sliderDots),
      countEl: section.querySelector(SELECTORS.sliderCount),
      cards: [],
      dots: [],
      ticking: false
    };

    function isMobileSlider() {
      if (!slider.scroller) return false;

      return (
        window.matchMedia('(max-width: 749px)').matches &&
        window.getComputedStyle(slider.scroller).display === 'flex'
      );
    }

    function collectSliderCards() {
      if (!slider.scroller) return [];

      return Array.from(slider.scroller.querySelectorAll(SELECTORS.card)).filter(card => {
        return window.getComputedStyle(card).display !== 'none';
      });
    }

    function buildSliderDots() {
      if (!slider.dotsWrap) return;

      slider.dotsWrap.innerHTML = '';
      slider.dots = [];

      slider.cards.forEach((card, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sc-bundle-builder__slider-dot';
        dot.setAttribute('aria-label', `Go to flavour ${index + 1}`);

        dot.addEventListener('click', () => {
          card.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
        });

        slider.dotsWrap.appendChild(dot);
        slider.dots.push(dot);
      });
    }

    function getActiveSliderIndex() {
      if (!slider.cards.length || !slider.scroller) return 0;

      const scrollerRect = slider.scroller.getBoundingClientRect();
      const scrollerCenter = scrollerRect.left + scrollerRect.width / 2;

      let activeIndex = 0;
      let closestDistance = Infinity;

      slider.cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;
        const distance = Math.abs(scrollerCenter - cardCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      return activeIndex;
    }

    function updateSliderMeta(forceRebuild = false) {
      if (!slider.meta || !slider.dotsWrap || !slider.countEl || !slider.scroller) return;

      if (!isMobileSlider()) {
        slider.meta.hidden = true;
        return;
      }

      slider.cards = collectSliderCards();

      if (!slider.cards.length) {
        slider.meta.hidden = true;
        return;
      }

      slider.meta.hidden = false;

      if (forceRebuild || slider.dots.length !== slider.cards.length) {
        buildSliderDots();
      }

      const activeIndex = getActiveSliderIndex();

      slider.countEl.textContent = `${activeIndex + 1} / ${slider.cards.length}`;

      slider.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }

    function initSlider() {
      if (!slider.scroller) return;

      slider.scroller.addEventListener('scroll', () => {
        if (slider.ticking) return;

        slider.ticking = true;

        window.requestAnimationFrame(() => {
          updateSliderMeta();
          slider.ticking = false;
        });
      }, { passive: true });

      window.addEventListener('resize', () => updateSliderMeta(true));
      window.addEventListener('load', () => updateSliderMeta(true));

      updateSliderMeta(true);
    }

    async function init() {
      initQuantityButtons();
      initModal();
      initSlider();

      cartQuantities = await fetchCartQuantities();

      updateControls();
    }

    init();
  }

  function initAllBundleBuilders() {
    document.querySelectorAll(SELECTORS.section).forEach(section => {
      initBundleBuilder(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBundleBuilders);
  } else {
    initAllBundleBuilders();
  }

  document.addEventListener('shopify:section:load', event => {
    if (!event.target) return;

    const section =
      event.target.matches?.(SELECTORS.section)
        ? event.target
        : event.target.querySelector?.(SELECTORS.section);

    if (section) {
      section.dataset.scandalBundleReady = 'false';
      initBundleBuilder(section);
    }
  });
})();